var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfo = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.543,
    height: 27.543,
    viewBox: "0 0 27.543 27.543",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5646",
    "data-name": "Group 5646",
    transform: "translate(-46 -600.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19188",
    "data-name": "Path 19188",
    d: "M48.623,40.1a.523.523,0,0,0-.523.523V49.3a.523.523,0,0,0,.523.523.506.506,0,0,0,.523-.523V40.623A.542.542,0,0,0,48.623,40.1Z",
    transform: "translate(10.765 571.402)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.881,
    cy: 0.881,
    rx: 0.881,
    ry: 0.881,
    transform: "translate(58.6 607.948)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19187",
    "data-name": "Path 19187",
    d: "M13.772,0A13.772,13.772,0,1,0,27.543,13.772,13.777,13.777,0,0,0,13.772,0Zm0,26.524A12.753,12.753,0,1,1,26.524,13.772,12.778,12.778,0,0,1,13.772,26.524Z",
    transform: "translate(46 600.457)",
    fill: "#fff",
    opacity: 0.75
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Info.5d85ab51.svg";
export { ForwardRef as ReactComponent };